const actions = {
  SET_STATE: 'authorizationCodes/SET_STATE',
  APPEND_AUTHORIZATION_CODES_LIST: 'authorizationCodes/APPEND_AUTHORIZATION_CODES_LIST',
  UPDATE_AUTHORIZATION_CODES_LIST: 'authorizationCodes/UPDATE_AUTHORIZATION_CODES_LIST',
  CREATE_AUTHORIZATION_CODE: 'authorizationCodes/CREATE_AUTHORIZATION_CODE',
  EDIT_AUTHORIZATION_CODE: 'authorizationCodes/EDIT_AUTHORIZATION_CODE',
  CREATE_FEE_SCHEDULE: 'authorizationCodes/CREATE_FEE_SCHEDULE',
  EDIT_FEE_SCHEDULE: 'authorizationCodes/EDIT_FEE_SCHEDULE',
  EDIT_STAFF_DRIVE_RATE: 'authorizationCodes/EDIT_STAFF_DRIVE_RATE',
  AUTHORIZATION_CODES_ACTIVE_INACTIVE: 'authorizationCodes/AUTHORIZATION_CODES_ACTIVE_INACTIVE',
  UPDATE_AUTHORIZATION_CODES_ACTIVE_INACTIVE:
    'authorizationCodes/UPDATE_AUTHORIZATION_CODES_ACTIVE_INACTIVE',
}

export default actions
